import { UserGroupUserPermission } from "api/interfaces/userInterface.interface";
import { CheckInput, ModalTableContainer } from "styles/ModalCommonStyled";
import DwPermissionCheckList from "./DwPermissionCheckList";
import { ValidateWord } from "components/atoms/text/Text";

interface Props {
  isEdit?: boolean;
  userCheckedList: UserGroupUserPermission;
  myDwDisabledList: UserGroupUserPermission;
  onChangeDwPermission: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isValidate: boolean;
  validateMsg: string;
}

function DwPermissionStep(props: Props): JSX.Element {
  return (
    <>
      <CheckInput>
        <input
          type="checkbox"
          name="enableAllPermissions"
          defaultChecked={props.userCheckedList.enableAllPermissions}
          checked={props.userCheckedList.enableAllPermissions}
          onChange={props.onChangeDwPermission}
          disabled={props.myDwDisabledList.enableAllPermissions}
          data-testid="users-user-group-steps-enable-all-permissions-change-dw-permission"
        />
        Administrator
      </CheckInput>

      <ModalTableContainer style={{ paddingTop: 16 }}>
        {!props.userCheckedList.enableAllPermissions && (
          <DwPermissionCheckList
            userCheckedList={props.userCheckedList}
            userDisabledList={props.myDwDisabledList}
            onChangeDwPermission={props.onChangeDwPermission}
          />
        )}
      </ModalTableContainer>
      {!props.userCheckedList.enableAllPermissions &&
        props.isValidate &&
        props.validateMsg && (
          <ValidateWord data-testid="users-user-group-steps-validate-dw-permission">
            {props.validateMsg}
          </ValidateWord>
        )}
    </>
  );
}

export default DwPermissionStep;
